import { Action } from "../../actions/types";

export type StoreState = string | null;

export const initialState = null;

function getTransactionIdFromAction(action: Action): string | null {
  if (action.type !== "EXCHANGE_REDEEM_SUCCESS") {
    return null;
  }
  // Loyalty redeem v2: response.data.transaction.transaction.id;
  // reward store: response.data.transaction.id
  const response = action.response;
  if (
    !response ||
    !response.data ||
    !response.data.transaction
  ) {
    return null;
  }
  const transaction = response.data.transaction;
  const id =
    transaction.id ||
    (transaction.transaction && transaction.transaction.id);

  return id != null ? id : null;
}

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "SET_EXCHANGE_ID") {
    return null;
  }

  if (action.type === "EXCHANGE_REDEEM_SUCCESS") {
    return getTransactionIdFromAction(action);
  }

  return state;
}
